import { Button } from 'reactstrap';
import styled from 'styled-components';

// Set the $hoverOnly prop to underline only on hover/focus/active
const UnderlinedLinkButton = styled(Button)`
  ${({ $hoverOnly }) => !$hoverOnly && '&,'}
  &:hover,
  &:focus,
  &:active {
    color: var(--overyield-blue);
    text-decoration: underline;
  }
`;

export default UnderlinedLinkButton;
